module.exports = __webpack_public_path__ + "static/amare_img_3_h-fbfd94df05ab4fd3170e5b077f9622d8.jpg";